import React from 'react';

const HeaderSection = () => {
  return (
    <div className="flex flex-col p-8 bg-inherit">
      <h3 className="text-[#ef8702] text-base font-black font-['Axiforma']">
        WHAT ARE WE DOING?
      </h3>
      
      <h1 className="text-5xl font-black font-['Axiforma'] text-black mt-2">
        Digitalizing And Valuing African Languages
      </h1>
      
      <p className="text-base font-normal  text-black mt-8 max-w-[629px]">
        At NKENNEAi, we believe in the transformative power of communication. By connecting Africa to the world through language, we open up possibilities that benefit individuals, businesses, and societies.
      </p>
    </div>
  );
};

HeaderSection.defaultProps = {
  title: 'Digitalizing And Valuing African Languages',
  description: 'At NKENNEAi, we believe in the transformative power of communication. By connecting Africa to the world through language, we open up possibilities that benefit individuals, businesses, and societies.'
};

export default HeaderSection;

